import React from "react";
import glyphData from "../data/glyphData";
import { useKami } from "../context/KamiContext";

/**
 * GlyphField.js
 *
 * Renders animated glyphs in a radial layout.
 * Clicking a glyph triggers memory focus and reveals detail.
 */

export default function GlyphField() {
  const { logGlyph } = useKami();

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "400px",
        border: "1px solid #00ffff",
        borderRadius: "20px",
        overflow: "hidden",
        marginBottom: "30px",
      }}
    >
      {glyphData.map((glyph, index) => {
        const angle = (index / glyphData.length) * 2 * Math.PI;
        const orbitX = Math.cos(angle) * 120;
        const orbitY = Math.sin(angle) * 120;

        return (
          <div
            key={glyph.id}
            onClick={() => logGlyph(glyph)}
            style={{
              position: "absolute",
              width: "40px",
              height: "40px",
              borderRadius: "999px",
              backgroundColor: glyph.color,
              top: `calc(50% + ${orbitY}px)`,
              left: `calc(50% + ${orbitX}px)`,
              transform: "translate(-50%, -50%)",
              animation: `pulse-${index} ${glyph.pulseRate}ms ease-in-out infinite alternate`,
              cursor: "pointer",
            }}
          />
        );
      })}

      <style>
        {glyphData.map((_, i) => `
          @keyframes pulse-${i} {
            from { transform: scale(1) translate(-50%, -50%); }
            to   { transform: scale(1.3) translate(-50%, -50%); }
          }
        `).join("\n")}
      </style>
    </div>
  );
}
